import { FILTER_CODE_MAP_TO_AGGREGATION_CODE } from '@/constants/filter-map';

export const generateNextState = ({
  attributeCode,
  value,
  label,
  prevStateIndex,
  prevActive,
  optionIdMapToRewrite,
  filterState,
  isSearchPage,
  hideColorsFamily,
}: {
  attributeCode: string;
  value: string;
  label: string;
  prevStateIndex: number;
  prevActive: boolean;
  optionIdMapToRewrite: Record<string, Record<string, string>>;
  filterState: FilterState;
  isSearchPage: boolean;
  hideColorsFamily: boolean;
}) => {
  const aggregationAttribute = FILTER_CODE_MAP_TO_AGGREGATION_CODE[attributeCode];

  if (prevStateIndex === -1) {
    if (attributeCode === 'price') {
      return filterState.concat({
        attributeCode,
        options: [
          {
            label,
            value,
            rewrite: value.replace('_', '-'),
          },
        ],
      });
    }

    if (attributeCode === 'category_id') {
      return filterState.concat({
        attributeCode,
        options: [
          {
            label,
            value,
            rewrite: '',
          },
        ],
      });
    }

    const rewrite = aggregationAttribute ? optionIdMapToRewrite[aggregationAttribute]?.[value] : '';

    if (!rewrite) {
      return filterState;
    }

    return filterState.concat({
      attributeCode,
      options: [
        {
          label,
          value,
          rewrite,
        },
      ],
    });
  }

  if (attributeCode === 'price') {
    return filterState.reduce<FilterState>((acc, x, i) => {
      if (prevActive) {
        return acc;
      }

      acc.push(
        i === prevStateIndex
          ? {
              attributeCode,
              options: [
                {
                  label,
                  value,
                  rewrite: value.replace('_', '-'),
                },
              ],
            }
          : x,
      );

      return acc;
    }, []);
  }

  if (attributeCode === 'category_id') {
    return filterState.reduce<FilterState>((acc, cur, i) => {
      if (i !== prevStateIndex) {
        acc.push(cur);
        return acc;
      }

      if (prevActive) return acc;

      acc.push({
        attributeCode: cur.attributeCode,
        options: [
          {
            label,
            value,
            rewrite: '',
          },
        ],
      });

      return acc;
    }, []);
  }

  const rewrite = aggregationAttribute ? optionIdMapToRewrite[aggregationAttribute]?.[value] : '';

  if (!rewrite) {
    return filterState;
  }

  if (attributeCode === 'custom_option_color_ids' && !isSearchPage && !hideColorsFamily) {
    return filterState.reduce<FilterState>((acc, cur, i) => {
      if (i !== prevStateIndex) {
        acc.push(cur);
        return acc;
      }

      const prevSelectedOptions = cur.options;
      const nextSelectedOptions = prevActive
        ? prevSelectedOptions.filter(x => x.value !== value)
        : prevSelectedOptions.concat({
            label,
            value,
            rewrite,
          });

      if (nextSelectedOptions.length !== 0) {
        acc.push({
          attributeCode,
          options: nextSelectedOptions,
        });
      }

      return acc;
    }, []);
  }

  return filterState.reduce<FilterState>((acc, cur, i) => {
    if (i !== prevStateIndex) {
      acc.push(cur);
      return acc;
    }

    if (prevActive) return acc;

    acc.push({
      attributeCode: cur.attributeCode,
      options: [
        {
          label,
          value,
          rewrite,
        },
      ],
    });

    return acc;
  }, []);
};
